var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodejs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 34,
    viewBox: "0 0 56 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.684 33.9019C27.4945 33.9019 27.3176 33.8519 27.1532 33.7643L25.4725 32.7757C25.2196 32.6379 25.3461 32.5879 25.4219 32.5629C25.7631 32.4503 25.8263 32.4252 26.1801 32.2251C26.2181 32.1999 26.2687 32.2125 26.3066 32.2375L27.5956 33.0009C27.6462 33.0259 27.7094 33.0259 27.7472 33.0009L32.7897 30.11C32.8402 30.085 32.8656 30.0349 32.8656 29.9724V24.2032C32.8656 24.1405 32.8402 24.0906 32.7897 24.0655L27.7472 21.1872C27.6967 21.1621 27.6335 21.1621 27.5956 21.1872L22.5531 24.0655C22.5026 24.0905 22.4772 24.1531 22.4772 24.2031V29.9723C22.4772 30.0224 22.5026 30.0849 22.5531 30.11L23.9307 30.8984C24.6763 31.2738 25.1439 30.8358 25.1439 30.3978V24.7037C25.1439 24.6287 25.2071 24.5535 25.2955 24.5535H25.94C26.0159 24.5535 26.0917 24.6161 26.0917 24.7037V30.3978C26.0917 31.3864 25.5482 31.9622 24.6004 31.9622C24.3098 31.9622 24.0823 31.9622 23.4377 31.6492L22.1108 30.8984C21.7822 30.7108 21.5801 30.3603 21.5801 29.9849V24.2157C21.5801 23.8403 21.7822 23.4898 22.1108 23.3021L27.1532 20.4113C27.4692 20.2361 27.899 20.2361 28.2149 20.4113L33.2573 23.3021C33.5859 23.4898 33.7881 23.8403 33.7881 24.2157V29.9849C33.7881 30.3603 33.5859 30.7108 33.2573 30.8984L28.2149 33.7893C28.0505 33.8644 27.861 33.9019 27.6841 33.9019H27.684ZM29.2385 29.9348C27.0269 29.9348 26.5719 28.9337 26.5719 28.0827C26.5719 28.0076 26.6351 27.9325 26.7236 27.9325H27.3808C27.4565 27.9325 27.5198 27.9825 27.5198 28.0577C27.6209 28.7209 27.9115 29.0463 29.2511 29.0463C30.3127 29.0463 30.7678 28.8085 30.7678 28.2453C30.7678 27.92 30.6413 27.6823 28.9858 27.5195C27.6082 27.3818 26.7489 27.0815 26.7489 25.9928C26.7489 24.9791 27.6083 24.3783 29.049 24.3783C30.6665 24.3783 31.4628 24.929 31.5639 26.1303C31.5639 26.168 31.5512 26.2054 31.526 26.243C31.5006 26.268 31.4628 26.293 31.4248 26.293H30.7677C30.7045 26.293 30.6413 26.243 30.6287 26.1804C30.477 25.4922 30.0852 25.2669 29.049 25.2669C27.8863 25.2669 27.7472 25.6674 27.7472 25.9677C27.7472 26.3306 27.9115 26.4432 29.4786 26.6434C31.0331 26.8438 31.7661 27.1316 31.7661 28.2078C31.7534 29.3091 30.8436 29.9348 29.2385 29.9348Z",
    fill: "#539E43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0385 11.3382C12.0385 11.113 11.9121 10.9001 11.7099 10.7875L6.35149 7.73403C6.26292 7.68389 6.16189 7.65888 6.06085 7.64632H6.01022C5.90919 7.64632 5.80804 7.68389 5.71958 7.73403L0.361171 10.7875C0.15888 10.9001 0.0325847 11.1129 0.0325847 11.3382L0.0452688 19.5477C0.0452688 19.6603 0.108471 19.7729 0.209507 19.8231C0.310653 19.8857 0.436948 19.8857 0.525518 19.8231L3.71023 18.021C3.91241 17.9084 4.03882 17.6956 4.03882 17.4704V13.6284C4.03882 13.4031 4.16511 13.1904 4.3674 13.0778L5.71958 12.3018C5.82073 12.2392 5.93445 12.2141 6.04817 12.2141C6.16189 12.2141 6.27561 12.2392 6.36418 12.3018L7.71635 13.0778C7.91865 13.1904 8.04494 13.403 8.04494 13.6284V17.4704C8.04494 17.6956 8.17135 17.9084 8.37353 18.021L11.5582 19.8231C11.6074 19.8538 11.6644 19.87 11.7225 19.87C11.7807 19.87 11.8376 19.8538 11.8868 19.8231C11.988 19.7729 12.0512 19.6603 12.0512 19.5477L12.0385 11.3382ZM37.7943 0.0375736C37.6932 -0.0125601 37.5668 -0.0125601 37.4783 0.0375736C37.3772 0.10016 37.314 0.200211 37.314 0.312822V8.44738C37.314 8.52242 37.2762 8.59745 37.2003 8.64759C37.1245 8.68505 37.0486 8.68505 36.9729 8.64759L35.6333 7.88421C35.535 7.82884 35.424 7.79972 35.311 7.79972C35.1979 7.79972 35.0869 7.82884 34.9887 7.88421L29.6302 10.9503C29.4281 11.0629 29.3017 11.2757 29.3017 11.5009V17.6204C29.3017 17.8457 29.4281 18.0585 29.6302 18.1712L34.9887 21.2372C35.0869 21.2926 35.1979 21.3217 35.311 21.3217C35.424 21.3217 35.535 21.2926 35.6333 21.2372L40.9917 18.1712C41.1938 18.0585 41.3202 17.8458 41.3202 17.6204V2.36527C41.3202 2.12749 41.1938 1.91483 40.9917 1.80211L37.7944 0.0375736H37.7943ZM37.3014 15.6057C37.3014 15.6683 37.2762 15.7183 37.2256 15.7433L35.3931 16.7945C35.3675 16.8068 35.3394 16.8133 35.311 16.8133C35.2825 16.8133 35.2544 16.8068 35.2288 16.7945L33.3964 15.7433C33.3457 15.7183 33.3205 15.6557 33.3205 15.6057V13.5032C33.3205 13.4406 33.3457 13.3906 33.3964 13.3656L35.2288 12.3143C35.2544 12.3019 35.2825 12.2955 35.311 12.2955C35.3394 12.2955 35.3675 12.3019 35.3931 12.3143L37.2256 13.3656C37.2762 13.3905 37.3014 13.4532 37.3014 13.5032V15.6057ZM55.6261 13.4532C55.8284 13.3406 55.9422 13.1278 55.9422 12.9025V11.4133C55.9422 11.1881 55.8158 10.9753 55.6261 10.8627L50.3057 7.80917C50.2075 7.7538 50.0964 7.72468 49.9834 7.72468C49.8704 7.72468 49.7593 7.7538 49.6611 7.80917L44.3027 10.8751C44.1004 10.9877 43.9741 11.2005 43.9741 11.4257V17.5454C43.9741 17.7706 44.1005 17.9834 44.3027 18.096L49.6231 21.0995C49.8254 21.2121 50.0656 21.2121 50.2552 21.0995L53.4777 19.3226C53.5789 19.2725 53.6421 19.1599 53.6421 19.0473C53.6421 18.9346 53.5789 18.822 53.4777 18.7719L48.094 15.7058C47.9929 15.6432 47.9297 15.5432 47.9297 15.4306V13.5159C47.9297 13.4033 47.9929 13.2906 48.094 13.2405L49.7748 12.2894C49.824 12.2587 49.881 12.2424 49.9391 12.2424C49.9972 12.2424 50.0542 12.2587 50.1034 12.2894L51.7843 13.2405C51.8854 13.3031 51.9485 13.4031 51.9485 13.5159V15.0176C51.9485 15.1302 52.0117 15.2428 52.1128 15.2929C52.162 15.3235 52.219 15.3398 52.2771 15.3398C52.3353 15.3398 52.3922 15.3235 52.4414 15.2929L55.6261 13.4532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9012 13.1653C49.92 13.153 49.9419 13.1465 49.9644 13.1465C49.9869 13.1465 50.0089 13.153 50.0276 13.1653L51.0513 13.7534C51.0891 13.7786 51.1144 13.816 51.1144 13.866V15.0425C51.1144 15.0925 51.0893 15.1301 51.0513 15.1551L50.0276 15.7433C50.0089 15.7555 49.9869 15.7621 49.9644 15.7621C49.9419 15.7621 49.92 15.7555 49.9012 15.7433L48.8776 15.1551C48.8397 15.1301 48.8144 15.0925 48.8144 15.0425V13.8662C48.8144 13.816 48.8396 13.7784 48.8776 13.7535L49.9012 13.1653Z",
    fill: "#539E43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3318 10.8751L20.9861 7.83418C20.9336 7.80792 20.8785 7.78695 20.8217 7.7716L14.8314 17.9335C14.881 17.9935 14.941 18.0443 15.0084 18.0837L20.3542 21.1247C20.5058 21.2123 20.6828 21.2373 20.847 21.1872L26.4709 11.0004C26.433 10.9504 26.3823 10.9127 26.3318 10.8752V10.8751Z",
    fill: "url(#paint0_linear_5_78)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1772 6.72031L20.1015 6.75788H20.2025L20.1772 6.72031Z",
    fill: "url(#paint1_linear_5_78)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3445 18.071C26.4962 17.9834 26.6099 17.8332 26.6605 17.6706L20.7964 7.75904C20.6447 7.73403 20.4804 7.74648 20.3415 7.83408L15.0336 10.8627L20.7584 21.1997C20.8417 21.1862 20.9225 21.1609 20.9985 21.1246L26.3444 18.0711L26.3445 18.071Z",
    fill: "url(#paint2_linear_5_78)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8368 17.9709L26.7995 17.9084V17.996L26.8366 17.9709H26.8368Z",
    fill: "url(#paint3_linear_5_78)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3445 18.071L21.0113 21.1121C20.9361 21.1501 20.8549 21.1754 20.7712 21.1871L20.8724 21.3748L26.7868 17.9835V17.9084L26.6351 17.658C26.6099 17.8332 26.4962 17.9834 26.3445 18.071Z",
    fill: "url(#paint4_linear_5_78)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3445 18.071L21.0113 21.1121C20.9361 21.1501 20.8549 21.1754 20.7712 21.1871L20.8724 21.3748L26.7868 17.9835V17.9084L26.6351 17.658C26.6099 17.8332 26.4962 17.9834 26.3445 18.071Z",
    fill: "url(#paint5_linear_5_78)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_78",
    x1: 19.8686,
    y1: 15.187,
    x2: 34.4084,
    y2: 7.20967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_78",
    x1: 15.642,
    y1: 6.72535,
    x2: 25.4846,
    y2: 6.72535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_78",
    x1: 14.5233,
    y1: 14.4732,
    x2: 26.8348,
    y2: 14.4732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_78",
    x1: 23.1796,
    y1: 17.9401,
    x2: 26.8099,
    y2: 17.9401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_78",
    x1: 14.5234,
    y1: 19.5267,
    x2: 26.8347,
    y2: 19.5267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09192,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_78",
    x1: 28.6284,
    y1: 9.81295,
    x2: 25.5678,
    y2: 26.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 34,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.8aa9fc966acc83caf87f713297f4a1a3.svg";
export { ForwardRef as ReactComponent };